'use strict';

export const url = 'login';
export const scope = '';


// WEBPACK FOOTER //
// ./src/config/auth.js